module.exports = __webpack_public_path__ + "images/ivecoa71b6ed6071f32466e7ae73f07fd9388.png";